export default {
    en: {
        incorrectResp: 'English version of Notification<br>Ошибка. Сервер вернул некорректный ответ',
        errNetwork: 'English version of Notification<br>Нет подключения к серверу',
        noData: 'English version of Notification<br>Нет данных',
        errRespData: 'English version of Notification<br>Ошибка при получении данных от сервера',
        deleted: 'English version of Notification<br>Удаление выполнено',
    },
    uk: {
        incorrectResp: 'Ошибка. Сервер вернул некорректный ответ',
        errNetwork: 'Нет подключения к серверу',
        noData: 'Нет данных',
        errRespData: 'English version of Notification<br>Ошибка при получении данных от сервера',
        deleted: 'Удаление выполнено',
    },
}